<template>
  <svg fill="none" height="17" viewBox="0 0 15 17" width="15" xmlns="http://www.w3.org/2000/svg">
    <rect height="13.4" rx="0.5" stroke="#999999" width="10.6667" x="3.16666" y="0.5" />
    <path d="M1 2.40015V15.0001C1 15.5524 1.44772 16.0001 2 16.0001H12.25" stroke="#999999" stroke-linecap="round" />
  </svg>
</template>
